import { useNavigate, useLocation } from "react-router-dom";
import { useCallback } from "react";

/**
 * A custom hook that wraps useNavigate to handle Admin-specific path prefixing.
 * If the current path starts with /mm, it ensures that all absolute navigations
 * to shared routes are also prefixed with /mm to stay within the MMLayout.
 */
export const useAdminNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/mm");

  const safeNavigate = useCallback(
    (to: string | number, options?: any) => {
      if (typeof to === "number") {
        return navigate(to);
      }

      // If we are in Admin mode and navigating to an absolute path that doesn't have /mm prefix
      if (isAdmin && to.startsWith("/") && !to.startsWith("/mm/")) {
        const targetPath = `/mm${to}`;
        return navigate(targetPath, options);
      }

      return navigate(to, options);
    },
    [navigate, isAdmin]
  );

  return safeNavigate;
};

export default useAdminNavigate;
